export default "__VITE_ASSET__$VBmQnOy__"